<template>
  <div class="blob-container" @click="show">
    <div class="inner">
      <v-icon>
        mdi-information-outline
      </v-icon>
      <div class="blob-text p-2">
        Ladda ner Livet i havet till din telefon. Klicka här för att se hur man
        gör!
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    show() {
      this.$router.push({ name: 'Video' })
    }
  }
}
</script>

<style lang="scss" scoped>
.blob-container {
  display: flex;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  top: -50px;
}
.inner {
  background-color: rgb(254, 226, 89) !important;
  display: flex;
  padding: 10px 20px;
}
.blob-text {
  font-size: 16px;
  color: #000;
  text-align: center;
  padding-left: 10px;
}
.blob-text span.text-bold {
  font-weight: 500;
}
</style>
